
import React from 'react';
import { Database, Search, Sparkles } from 'lucide-react';

interface ResponseTypeIconProps {
  type?: string;
}

export const ResponseTypeIcon: React.FC<ResponseTypeIconProps> = ({ type }) => {
  switch (type) {
    case 'sql':
      return <Database className="h-3 w-3 mr-1" />;
    case 'embeddings':
      return <Sparkles className="h-3 w-3 mr-1" />;
    case 'semantic':
    default:
      return <Search className="h-3 w-3 mr-1" />;
  }
};
